import { X } from 'lucide-react';
import { StatusType } from '../shared/types/inventory';

interface ProductHeaderProps {
  name: string;
  ean: string;
  status: StatusType;
  statusLabel: string;
  onClose: () => void;
}

export const ProductHeader = ({ name, ean, status, statusLabel, onClose }: ProductHeaderProps) => {
  const getStatusColors = () => {
    switch (status) {
      case 'ruptura':
        return 'bg-red-50 text-red-700 border-red-200';
      case 'iminente':
        return 'bg-orange-50 text-orange-700 border-orange-200';
      case 'critica':
        return 'bg-yellow-50 text-yellow-700 border-yellow-200';
      case 'minimo':
        return 'bg-yellow-50 text-yellow-600 border-yellow-200';
      case 'excesso':
        return 'bg-cyan-50 text-cyan-700 border-cyan-200';
      default:
        return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    }
  };

  return (
    <div className="bg-gradient-to-r from-slate-50 to-slate-100 border-b border-slate-200 px-8 py-6">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h2 className="text-2xl font-semibold text-slate-900 tracking-tight">{name}</h2>
            <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColors()}`}>
              {statusLabel}
            </span>
          </div>
          <p className="text-sm text-slate-500 font-mono">EAN: {ean}</p>
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-slate-200 rounded-lg transition-all duration-200 group"
        >
          <X className="w-5 h-5 text-slate-400 group-hover:text-slate-600" />
        </button>
      </div>
    </div>
  );
};
